import axios from 'axios'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
//URL
import configData from "../../../config.json";
//Componentes
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';
import { CertificadoDescarga, DescargarCertificado, functionFormatISODate, HistoriaSolicitudesCertificadoColumn, parseEstado, parseTipoCertificado, SolicitudCertificado } from 'components/UsuarioGeneral/Solicitud Certificados/Solicitud_Certificados';
import { alertService } from 'components/Varios/alert_service';
import Cargando from 'components/Varios/Cargando';
import ModalFirmarCertificado from './ModalFirmarCertificado';
import { handle_error } from 'components/DirectivoUnidad/Vacaciones/helper_function';
import { auxiliarParsearInfotoTable, DataSolicitudesCeritificadosTable, DatosSolicitudXML, DatosVistaPrevia, InfoSolicitudCertificadosAnalista } from './AnalistaAdministraSolicitudesCertificados';
//React-Bootstrap
import { Container, Row, Col, Table, Button } from 'react-bootstrap';
import TableDirectorTHCertificados from './TableDirectorTHCertificados';
import ModalCargando from 'components/Varios/ModalCargando';
import { ModalFirmaMasivaCertificados } from './ModalFirmaMasivaCertificados';
import CertificacionProfesional from 'components/CertificacionProfesional';
import ModalRechazo from 'components/DirectivoUnidad/AprobacionSolicitudes/ModalRechazoSolicitud';
import { ReversarEmisionCertificado } from './FunctionsCertificadosDirectorTH';
import TablaDetalles from 'components/Varios/Modals/TablaDetallesModalBody/TablaDetalles';



const ERRORES_CERTIFICADOSFIRMAR = {
    certificadosFirmados: "No se ha podido obtener información de certificados firmados",
    certificadosPendientesFirmar: "No se ha podido obtener información de las solicitudes",
    rowsTablaCertificadosDirector: "Ha ocurrido un inconveniente al intentar obtener información de las solicitudes de la tabla."
}


export type DatosModalFirmarCertificado = {
    url: string,
    referenciaCertificado?: string,
    idCertificado: number
}

export type DatosSolicitudAcciones = {
    referenciaCertificado?: string
    idCertificado: number,

}

export type DatosModalNegarEmisionCertificado = {
    datos:CertificadoDescarga,
    contentModal:React.ReactElement
}

export default function FirmarCertificados() {
    const [DatosTablaSolicitudes, setDatosTablaSolicitudes] = useState<HistoriaSolicitudesCertificadoColumn[]>([])
    const [loading, setloading] = useState<boolean>(false);
    const [datosSolicitudUsando, setdatosSolicitudUsando] = useState<DatosSolicitudAcciones>({
        idCertificado: -1,
    })
    const [referenciaCertificado, setreferenciaCertificado] = useState<string>("")

    //Informacion Modal para firmar Certificado
    const [showModalFirmarCertificado, setshowModalFirmarCertificado] = useState<boolean>(false)
    const [datosModalFirmar, setdatosModalFirmar] = useState<DatosModalFirmarCertificado>({
        url: "",
        idCertificado: -1
    })
    const [loadingmodalFirmar, setloadingmodalFirmar] = useState<boolean>(false)



    //Tabla Certificados de Solicitudes Firmadas
    const [DataTableSolicitudesEmitidasFirmadas, setDataTableSolicitudesEmitidasFirmadas] = useState<DataSolicitudesCeritificadosTable[]>([])


    //Informacion de Tabla similar a la de los analistas
    const [rowsTableSolicitudes, setrowsTableSolicitudes] = useState<DataSolicitudesCeritificadosTable[]>([])
    const [TablaSolicitudesDirector, setElementoTablaSolicitudesDirector] = useState<HTMLElement | undefined>(undefined)
    const [anioSeleccionadoConsulta, setanioSeleccionadoConsulta] = useState<number>(-1);

    //Modal de certificados a firma
    const [certificadosSeleccionados, setcertificadosSeleccionados] = useState<Array<CertificadoDescarga>>([])
    const [showModalFirmaMasivaCertificados, setshowModalFirmaMasivaCertificados] = useState<boolean>(false)

    //Modal para negar/reversar emisión de certificado
    const [modalNegarEmisionCertificado, setmodalNegarEmisionCertificado] = useState<DatosModalNegarEmisionCertificado|undefined>(undefined)

    function ReiniciarModalFirmarCertificado() {
        setdatosModalFirmar({ url: "", idCertificado: -1 })
        setreferenciaCertificado("")
        setdatosSolicitudUsando({
            idCertificado: -1,
        })
        setshowModalFirmarCertificado(false)
        document.body.classList.remove('modal-open')
    }

    function ReiniciarModalFirmaMasiva() {
        setcertificadosSeleccionados([])
        setshowModalFirmaMasivaCertificados(false)
        document.body.classList.remove('modal-open')
    }

    // const ObtenerSolicitudesPorFirmar = async (datosPersonas: UserData) => {
    //     setloading(true);
    //     try {
    //         const respuesta = await axios.get(configData.SERVER_URL + "GenerarCertificados/Director/CertificadosFirmar",
    //             {
    //                 headers: {

    //                     Authorization: `KEYESPOL ${datosPersonas.token}`

    //                 }
    //             });

    //         var datos: SolicitudCertificado[] = respuesta.data;

    //         var arregloDatosTabla: HistoriaSolicitudesCertificadoColumn[] = [];
    //         datos.map((sol) => {
    //             arregloDatosTabla.push({
    //                 tip: sol.nombreCertificado,
    //                 fecs: sol.fechasolicitud,
    //                 obs: sol.observaciones,
    //                 est: parseEstado(sol.idcertificadotipo, sol.estadosolicitud),
    //                 estc: parseEstado(sol.idcertificadotipo, sol.estadoCertificado, sol.estadosolicitud),
    //                 cert: {
    //                     referencia: sol.referenciaCertificado,
    //                     estadocertificado: sol.estadoCertificado,
    //                     idcertificado: sol.idcertificadoth,
    //                     certificadoAutomatizado: sol.automatizado,
    //                     nombreTipoCertificado: sol.nombreCertificado,
    //                     estadoSolicitud: sol.estadosolicitud,
    //                     idTipoCertificado: sol.idcertificadotipo,
                        


    //                 },
    //                 anularSolicitud: {
    //                     estadosolicitud: sol.estadosolicitud,
    //                     idSolicitud: sol.idsolcertth
    //                 },
    //                 noms: sol.nombres

    //             })


    //         })
    //         setDatosTablaSolicitudes(arregloDatosTabla);
    //     } catch (error) {
    //         alertService.error(ERRORES_CERTIFICADOSFIRMAR.certificadosPendientesFirmar)
    //     }
    //     setloading(false);
    // }

    const ObtenerSolicitudesCertificadosFirmados = async (datosPersonas: UserData) => {
        // setloadingCertificadosFirmados(true)
        // try {
        //     const respuesta = await axios.get(configData.SERVER_URL + "GenerarCertificados/Director/CertificadosFirmadosGuardados",
        //         {
        //             headers: {

        //                 Authorization: `KEYESPOL ${datosPersonas.token}`

        //             }
        //         });
        //     const certificadosFirmados: Array<InfoSolicitudCertificadosAnalista> = respuesta.data;
        //     const dataTableCertificadosFirmados: Array<DataSolicitudesCeritificadosTable> = auxiliarParsearInfotoTable(certificadosFirmados);
        //     setDataTableSolicitudesEmitidasFirmadas(dataTableCertificadosFirmados);
        // } catch (error) {
        //     alertService.error(ERRORES_CERTIFICADOSFIRMAR.certificadosFirmados)

        // }
        // setloadingCertificadosFirmados(false)

    }

    async function ObtenerAniosDisponiblesParaConsulta() {
        setloading(true);
        const datosUsuario: UserData = authenticationService.currentUserValue;

        try {
            const respuesta = await axios.get(configData.SERVER_URL + "SolicitudCertificados/Analista/YearsSolicitudes", {
                headers:
                {
                    'Content-Type': 'application/json',
                    Authorization: `KEYESPOL ${datosUsuario?.token}`,

                }
            });

            const listadoAniosParaConsulta: number[] = respuesta.data;

            if (listadoAniosParaConsulta.length >= 1) {
                setanioSeleccionadoConsulta(listadoAniosParaConsulta[0]);
            }



        } catch (error) {
            if (axios.isAxiosError(error) && error.response && error.response.data) {
                alertService.error(error.response.data);
            }
            else {
                alertService.error("Ha ocurrido un inconveniente al intentar obtener información sobre las solicitudes de certificados.")
            }

        }
        setloading(false);
    }



    const ObtenerInformacionSolicitudesDirector = async (anioSeleccionado: number) => {
        setloading(true)

        try {
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const respuesta = await axios.get(configData.SERVER_URL + `SolicitudCertificados/Analista/SolicitudesPendientes/D/${anioSeleccionado}`, {
                headers:
                {
                    'Content-Type': 'application/json',
                    Authorization: `KEYESPOL ${datosUsuario?.token}`,

                }
            });

            var info: InfoSolicitudCertificadosAnalista[] = respuesta.data;
            setrowsTableSolicitudes(auxiliarParsearInfotoTable(info, true));
        } catch (error) {
            alertService.error(ERRORES_CERTIFICADOSFIRMAR.rowsTablaCertificadosDirector)
        }
        setloading(false);

    }


    const ObtenerCertificado = async (datosUsuario: UserData, idCertificado: number, referencia?: string) => {
        setloadingmodalFirmar(true)
        const urlGetCertificado = `GenerarCertificados/Director/CertificadoPorFirmar/${idCertificado}`
        await fetch(configData.SERVER_URL + urlGetCertificado, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `KEYESPOL ${datosUsuario.token}`,

            },
        })
            .then(response => {
                response.blob()
                    .then(blob => {
                        let url = window.URL.createObjectURL(blob);
                        var file_object = new File([blob], "certificado");
                        if (referencia) {
                            setdatosModalFirmar({ url, idCertificado, referenciaCertificado: referencia });

                        }
                        else {
                            setdatosModalFirmar({ url, idCertificado });

                        }

                    });

            })

            .catch((error) => {
                var error_any: any = error;
                var status_code: number = handle_error(error_any);
                switch (status_code) {
                    case 0:
                        alertService.error("No se ha podido establecer contacto con el servidor");
                        break;
                    case 500:
                        alertService.error("Ha ocurrido un error inesperado");
                        break;
                    default:
                        alertService.error("Ha ocurrido un error desconocido");
                        break;
                }
                window.scrollTo({
                    top: 0,
                    behavior: "auto"
                });
            });
        setloadingmodalFirmar(false)


    }

    const HandleClickFirmarCertificadosSeleccionados = (certificadosporFirmar: Array<CertificadoDescarga>) => {
        setcertificadosSeleccionados(certificadosporFirmar);
    }


    const handleCertificadoFirmado = useCallback(
      async () => {
        setshowModalFirmarCertificado(false)
        ReiniciarModalFirmarCertificado()
        var datospersona: UserData = authenticationService.currentUserValue;
        alertService.success("Certificado firmado con éxito")
        // ObtenerSolicitudesPorFirmar(datospersona)
        // ObtenerSolicitudesCertificadosFirmados(datospersona)
        await ObtenerInformacionSolicitudesDirector(anioSeleccionadoConsulta)
        window.scrollTo({
            top: 0,
            behavior: "auto"
        });
      },
      [anioSeleccionadoConsulta],
    )
    

   
    const HandleClickFirmarCertificado = (value: CertificadoDescarga) => {

        if (value.idcertificado && value.certificadoAutomatizado) {
            setdatosSolicitudUsando({
                idCertificado: value.idcertificado
            })
        }
        else if (value.idcertificado && !value.certificadoAutomatizado && value.referencia) {
            setdatosSolicitudUsando({
                idCertificado: value.idcertificado,
                referenciaCertificado: value.referencia
            })
        }
    }


    const HandleClickReversarEmisionCertificado = (datosCertificado:CertificadoDescarga) => {

        interface MapeoCertificadoDescarga {           
            Solicitante:string,
            Tipo_Certificado:string,
            Fecha_Solicitud:string,
            Fecha_Emision:string
        }



        const listadoMapeado:MapeoCertificadoDescarga = {
            Solicitante: datosCertificado.nombreSolicita??"",
            Tipo_Certificado: datosCertificado.nombreTipoCertificado,
            Fecha_Emision:datosCertificado.fechaEmisionCertificado,
            Fecha_Solicitud:datosCertificado.fechaSolicitudFormato

        }


        const contentModal:React.ReactElement = (
            <Row>
                <Col xl={12}>
                    <div><strong>{"Información del certificado:"}</strong></div>
                </Col>
                <Col xl={12}>
                    {
                        <TablaDetalles<MapeoCertificadoDescarga>
                            registrosTabla={[listadoMapeado]}
                        />
                    }
                </Col>
            </Row>
        )
        setmodalNegarEmisionCertificado({datos:datosCertificado,contentModal})
    }   


    const handlefirmaMasivaCompleta = useCallback(
        async () => {
            setshowModalFirmaMasivaCertificados(false)
            var datospersona: UserData = authenticationService.currentUserValue;
            ReiniciarModalFirmaMasiva()
            await ObtenerInformacionSolicitudesDirector(anioSeleccionadoConsulta)
            window.scrollTo({
                top: 0,
                behavior: "auto"
            });
        },
        [anioSeleccionadoConsulta],
    )



    async function handleDescargarCertificado(referencia?: string) {
        if (!referencia) {
            alertService.error("No ha sido posible descargar el certificado");
            return
        }
        else {
            await DescargarCertificado(referencia)
        }
    }


    async function ReversarCertificadoLocal(observacion:string,idcertificado:number){
        const status = await ReversarEmisionCertificado(idcertificado,observacion)
        setmodalNegarEmisionCertificado(undefined);
        return status;
    }


    useEffect(() => {
        const datosUsuario: UserData = authenticationService.currentUserValue;
        if(anioSeleccionadoConsulta > -1){
            ObtenerInformacionSolicitudesDirector( anioSeleccionadoConsulta)

        }
    }, [anioSeleccionadoConsulta])



    useEffect(() => {
        ObtenerAniosDisponiblesParaConsulta();
    }, [])


    // useEffect(() => {
    //     var datosUsuario: UserData = authenticationService.currentUserValue;

    //     if (datosUsuario) {
    //         // ObtenerSolicitudesPorFirmar(datosUsuario);
    //         // ObtenerSolicitudesCertificadosFirmados(datosUsuario)
    //         ObtenerInformacionSolicitudesDirector(datosUsuario)
    //     }

    // }, [])

    useEffect(() => {
        const { idCertificado } = datosSolicitudUsando;
        var datosUsuario: UserData = authenticationService.currentUserValue;

        if (idCertificado > 0 && !datosSolicitudUsando.referenciaCertificado) {

            if (datosUsuario) {
                ObtenerCertificado(datosUsuario, idCertificado)
            }

        }
        else if (idCertificado > 0 && datosSolicitudUsando.referenciaCertificado) {
            ObtenerCertificado(datosUsuario, idCertificado, datosSolicitudUsando.referenciaCertificado)

        }
    }, [datosSolicitudUsando.idCertificado])


    useEffect(() => {
        const { url } = datosModalFirmar
        if (url) {
            setshowModalFirmarCertificado(true)
        }
    }, [datosModalFirmar.url])


    async function HandleChangeAnioTable(anio: number) {
        setanioSeleccionadoConsulta(anio);
    }

    useEffect(() => {
        var elementoMostrar: any = <Cargando />
        if (rowsTableSolicitudes.length === 0 && loading) {
            elementoMostrar = (
                <div>
                    <Cargando mensaje='Cargando tabla solicitudes certificados' />
                </div>
            )
            setElementoTablaSolicitudesDirector(elementoMostrar)
        }
        // if (rowsTableSolicitudes.length === 0 && !loading) {
        //     elementoMostrar = (
        //         <div>
                    
        //         </div>
        //     )
        //     setElementoTablaSolicitudesDirector(elementoMostrar)
        // }
        else {
            elementoMostrar = (
                <TableDirectorTHCertificados
                    dataprops={rowsTableSolicitudes}
                    onClickFirmarCertificado={(value: CertificadoDescarga) => {
                        HandleClickFirmarCertificado(value)
                    }}
                    onClickReversarEmisionCertificado ={(value: CertificadoDescarga) => {
                        HandleClickReversarEmisionCertificado(value)
                    }}
                    onClickFirmarCertificadosSeleccionados={(certificadosSeleccionados: CertificadoDescarga[]) => {
                        HandleClickFirmarCertificadosSeleccionados(certificadosSeleccionados)
                    }}
                    handleDescargarCertificado={(referenciaCertificado: string) => handleDescargarCertificado(referenciaCertificado)}
                    anioSeleccionado={anioSeleccionadoConsulta}
                    onChangeYear={async (anioSeleccionado: number) => await HandleChangeAnioTable(anioSeleccionado)}
                />
            )
            setElementoTablaSolicitudesDirector(elementoMostrar)
        }


    }, [rowsTableSolicitudes,loading])

    useEffect(() => {
        if (certificadosSeleccionados.length != 0) {
            setshowModalFirmaMasivaCertificados(true)
        }
    }, [certificadosSeleccionados])





    if (loading) {
        return <Cargando />
    }
    return (
        <div className="content">
            <Container fluid>

                <Row>
                    <Col>
                        <div> Firmar Certificados  </div>
                    </Col>
                </Row>
                {
                    TablaSolicitudesDirector
                }
                <ModalFirmarCertificado
                    show={showModalFirmarCertificado}
                    toogle={() => setshowModalFirmarCertificado(!showModalFirmarCertificado)}
                    onClose={() => ReiniciarModalFirmarCertificado()}
                    datosparaFirmar={datosModalFirmar}
                    handleCertificadoFirmado={() => handleCertificadoFirmado()}

                />
                <ModalCargando
                    show={loadingmodalFirmar}
                    onClose={() => setloadingmodalFirmar(false)}
                    size={"sm"}
                    textoCargando={"Cargando información del certificado"}

                />

                <ModalFirmaMasivaCertificados
                    show={showModalFirmaMasivaCertificados}
                    toogle={() => setshowModalFirmaMasivaCertificados(!showModalFirmaMasivaCertificados)}
                    datos={certificadosSeleccionados}
                    onClose={() => ReiniciarModalFirmaMasiva()}
                    onFirmaCompleata={() => handlefirmaMasivaCompleta()}
                />

                <ModalRechazo
                    show={modalNegarEmisionCertificado !== undefined && modalNegarEmisionCertificado.datos.idcertificado !== undefined}
                    size="lg"
                    onClose={() => setmodalNegarEmisionCertificado(undefined)}
                    asyncAccion={true}
                    asyncClose={true}
                    closeAfterAccion={true}
                    hideBotonCerrar={false}
                    mensajeConfirmacion={"¿Está seguro/a que desea reversar el certificado emitido?"}
                    nombreBotonAccion={"SI"}
                    nombreBotonCerrarModal={"NO"}
                    asyncOnClick={async (observacion) => await ReversarCertificadoLocal(observacion,modalNegarEmisionCertificado?.datos.idcertificado??-1)}
                    contentModal={modalNegarEmisionCertificado?.contentModal}
                    tituloModal={"Reversar emisión de Certificado"}
                    asyncAfterOnClose={() =>  ObtenerInformacionSolicitudesDirector(anioSeleccionadoConsulta)}
                    labelObservacion={"Indique el motivo de reverso"}
                    botonesAccionParteSuperior={true}
                    classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                    maxLength={300}
                    
                />


            </Container>

        </div>
    )
}
